import axios from 'axios';
import {
  FileDownloadJob,
  FileDownloadJobRegisterParams,
} from '@/types/dashboard';

export async function registerUsageFileDownloadJob(
  params: FileDownloadJobRegisterParams,
): Promise<FileDownloadJob> {
  const { data } = await axios.post<FileDownloadJob>(
    '/dashboard/downloads',
    params,
  );
  return data;
}

export async function downloadFile(id: number): Promise<string> {
  const { data } = await axios.get(`/dashboard/downloads/${id}/url`);
  return data?.url;
}

export async function cancelUsageFileDownloadJob(id: number): Promise<void> {
  await axios.put(`/dashboard/downloads/${id}`);
}

export async function deleteUsageFileDownloadJob(id: number): Promise<void> {
  await axios.delete(`/dashboard/downloads/${id}`);
}
